import { render, staticRenderFns } from "./TeachersSection.vue?vue&type=template&id=6c03617a&scoped=true&"
import script from "./TeachersSection.vue?vue&type=script&lang=js&"
export * from "./TeachersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03617a",
  null
  
)

export default component.exports